import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  getDirectoryAllUsers,
  getMisc,
  updateDirectory,
} from "../../../apiclients/streamsapi_bridge";
import PopupLoaderNew from "../../../views/popups/PopupLoaderNew";
import AddToUsers from "../../../views/popups/misc/AddToUsers";
import RemoveToUser from "../../../views/popups/misc/RemoveToUser";
import { MDBAlert, MDBBtn, MDBDatatable, MDBIcon, MDBInput } from "mdb-react-ui-kit";
import { customSearch, useAutoFocusSearchAfterLoads } from "../../CustomSearchUtil/CustomSearch";
import UIConstant from "../../../apiclients/UIConstant";

function AADialByNameEditUser(props) {
  const [deleteUserFlag, setDeleteUserFlag] = useState(false);
  const [isdelete, setIsDelete] = useState(false);
  const dtogglePopup = () => setIsDelete(!isdelete);
  const [updateUsers, setUpdateUsers] = useState([]);
  const [isAddedUsers, setIsAddedUsers] = useState(false);
  const [sourceFlag, setSourceFlag] = useState(true);
  const [isdeleteUser, setIsDeleteUser] = useState(false);
  const { t, i18n } = useTranslation();
  const [usersUpdated, setUsersUpdated] = useState(false);
  const [aaDirectoryUser, setAADirectoryUser] = useState([]);
  const [addUser, setAddUser] = useState(false);
  const toggleUser = () => setAddUser(!addUser);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [sourceUsers, setSourceUsers] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [addedUsers, setAddedUsers] = useState([]);
  const [removedUsers, setRemovedUsers] = useState({});
  const [updateUsersExecuted, setUpdateUsersExecuted] = useState(false);
  const [internalError, setInternalError] = useState(false);
  const [rerender, setRerender] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [filteredRows, setFilteredRows] = useState([]);
  const addUserRef = useRef(null);
  const [isLoading, setisLoading] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);

    useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded,searchRef,props.isActive)
  function handleClick() {
    addUserRef.current.click();
  }

  useEffect(() => {
    if (successMessage) {
      setTimeout(() => {
        setSuccessMessage(""); // Clear the success message in the parent component
      }, 5000);
    }
  }, [successMessage]);

  useEffect(() => {
    async function getAllDirectoryUsers() {
      const response = await getDirectoryAllUsers(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        props.directoryInfo.id
      );
      if (!response.json) {
        const message = `An error has occured: ${response.statusText}`;
        return;
      }
      const rawData = await response.json();
      if (!rawData) {
        window.alert(`info with id  not found`);
      }
      console.log(
        `all AA Directories ::::: ` + JSON.stringify(rawData?.data?.user_info)
      );
      const directoryList = rawData?.data?.user_info ?? [];
      const addUserList = directoryList?.length >0 ? sourceUsers.filter(userList => 
        !directoryList?.some(item2 => item2.agentid === userList.agentid)
      ) : sourceUsers
      setSourceUsers(addUserList);
      processUserDtlsFraming(directoryList);
    }

    if (props.isActive || rerender) {
      getAllDirectoryUsers();
      setRerender(false);
    }
  }, [props.isActive, rerender]);

  function deleteSelectedUser(event, infoObj) {
    event.preventDefault();
    event.stopPropagation();
    setUpdateUsers([infoObj]);
    dtogglePopup();
  }

  function processUserDtlsFraming(groupInfo) {
    let proccessdRows = [];
    groupInfo.map((infoObj) => {
      let processedRow = {
        id: infoObj?.id ?? "",
        name: infoObj.name,
        extension: infoObj.extension,
        agentid: infoObj.agentid,
        location_name:infoObj?.location_name,
        // code: infoObj.code,

        delete: (
          <i
            className="fas ms-3 fa-xmark text-primary cursor-pointer"
            href="#"
            onClick={(e) => deleteSelectedUser(e, infoObj)}
            defaultValue={infoObj.id}
            target="_new"
          />
        ),
      };
      proccessdRows.push(processedRow);
    });
    console.log("proccessdRows :::::::::: " + JSON.stringify(proccessdRows));
    setAADirectoryUser(proccessdRows);
    setFilteredRows(proccessdRows)
    setDataLoaded(true)
  }

  let columnsInfo = [
    { label: "Name", field: "name", sort: true },
    { label: "Extension", field: "extension", sort: true },
    { label: "Remove", field: "delete", sort: false },
  ];

 const handleManualSearch = (searchValue) =>{
    setSearchValue(searchValue); 
    const filtered = customSearch(aaDirectoryUser, searchValue, UIConstant.AA_DIAL_BY_NAME_EDITUSER);
  
    setFilteredRows(filtered);
  };

  useEffect(() => {
    async function fetchData() {
      let UserList = [],
        apiResponse = {};

      apiResponse = await getMisc(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        { misc: ["role_users"] }
      );
      if (apiResponse.status === 200) {
        UserList = await apiResponse.json();

        UserList = UserList.misc.users;
        const addUserList = aaDirectoryUser?.length >0 ? UserList.filter(userList => 
          !aaDirectoryUser?.some(item2 => item2.agentid === userList.agentid)
        ) : UserList
        setSourceUsers(addUserList);
      } else {
      }
    }

    if (sourceFlag) {
      fetchData();
      setSourceFlag(false);
    }
  }, [sourceFlag]);

  useEffect(() => {
    if (updateUsers.length > 0 && isAddedUsers) {
      updateTheUser("added_users");
      setIsAddedUsers(false);
    }
  }, [updateUsers, isAddedUsers]);

  useEffect(() => {
    if (updateUsers.length > 0 && isdeleteUser) {
      updateTheUser("removed_users");
      setIsDeleteUser(false);
    }
  }, [updateUsers, isdeleteUser]);

  async function updateTheUser(fieldName) {
    const agentids = new Set(updateUsers.map((item) => item.agentid));
    let update = {
      reqid: 148,
      directory_id: props.directoryInfo.id,
      siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      [fieldName]: Array.from(agentids),
    };

    console.log(JSON.stringify(update));

    let saverep = await updateDirectory(update);
    console.log(saverep);
    let saverepeMsg = await saverep.json();
    // alert(JSON.stringify(saverepeMsg));
    const usernames = new Set(updateUsers.map((item) => item.name));
    const users = Array.from(usernames).join(", ");
    if (saverepeMsg.status && saverepeMsg.status == "success") {
      //debugger;
      if (fieldName === "added_users") {
        setRerender(true);
        setSuccessMessage(`User(s) ${users} added successfully.`);
        // setUsersUpdated(true);
      } else {
        setRerender(true);
        setSourceUsers(prev=> [...prev,...updateUsers])
        // setUsersUpdated(true);
        setSuccessMessage(`User(s) ${users} removed successfully.`);
      }
    } else {
      setRerender(true);
        setInternalError(true);
      
    }
  }

  function modifyTheUserList() {
    let updatedUser = [];
    // alert(JSON.stringify(removedUsers));
    // alert(deleteUserFlag);
    if (deleteUserFlag) {
      updatedUser = selectedUsers.filter(
        (item) => removedUsers.agentid !== item.agentid
      );

      setDeleteUserFlag(false);
    } else {
      updatedUser = [...selectedUsers, ...addedUsers];
    }
    setSelectedUsers(updatedUser);
    setUpdateUsersExecuted(false);
    processUserDtlsFraming(updatedUser);
  }

  useEffect(() => {
    if (updateUsersExecuted) {
      modifyTheUserList();
    }
  }, [updateUsersExecuted]);

  return (
    <>
      <h5 className="mb-0  d-flex align-items-center justify-content-between">
        <div className="general-settings">{t("users")}</div>
        <MDBBtn
          onClick={(e) => {
            e.preventDefault();
            toggleUser();
          }}
        >
          <MDBIcon fas icon="plus" size="sm" className="me-2" />
          {t("addusers")}
        </MDBBtn>
      </h5>
      <div className="actionbar"></div>
      <div className='mb-2 mt-0 position-relative w-auto'>
                        <MDBInput
                          label="Search"
                          ref={searchRef}
                          value={searchValue}
                          onChange={(e) => handleManualSearch(e.target.value)}
                        />
                        <MDBIcon fas icon="search" className='MDBDatatable-Search' />
                      </div>
      <MDBDatatable
        className="actioncolumn"
          key={searchValue}
        // search
        entries={50}
        sortField="Name"
        data={{
          columns: columnsInfo,
          rows: filteredRows,
        }}
      />
      {isdelete && (
        <PopupLoaderNew
          title={"Remove User"}
          content={
            <RemoveToUser
              setIsDeleteUser={setIsDeleteUser}
              onClose={dtogglePopup}
              ref={addUserRef}
              setIsloading={setisLoading}
            />
          }
          onShow={setIsDelete}
          onClose={dtogglePopup}
          onSave={handleClick}
          isloading={isLoading}
          flag={4}
        />
      )}
      {addUser && (
        <PopupLoaderNew
          // size="lg"
          // className="modal-lg"
          title={t("Add Users")}
          content={
            <AddToUsers
              onClose={toggleUser}
              selectedUsers={selectedUsers}
              setUpdateUsers={setUpdateUsers}
              setIsAddedUsers={setIsAddedUsers}
              sourceUsers={sourceUsers}
              ref={addUserRef}
              setIsloading={setisLoading}
            />
          }
          onShow={setAddUser}
          onClose={toggleUser}
          onSave={handleClick}
          isloading={isLoading}
          flag={2}
        />
      )}
      {successMessage && (
        <MDBAlert
          open
          className="alert-center"
          color="success"
          autohide
          position="bottom-right"
          delay={10000}
        >
          <i className="fas fa-check-circle me-3"></i>
          <span className="alert-msg">{successMessage}</span>
        </MDBAlert>
      )}
      {internalError && (
                  <MDBAlert
                    open
                    className="alert-center"
                    color="danger"
                    autohide
                    position="bottom-right"
                    delay={5000}
                    onClose={() => setInternalError(false)}
                  >
                    Internal Server Error
                  </MDBAlert>
                )}
    </>
  );
}

export default AADialByNameEditUser;
